var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiSparkle = function SvgAiSparkle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.28218 2 8.53462 2.17457 8.63384 2.43869L9.97869 6.02205L13.5613 7.36567C13.8253 7.46479 13.9998 7.71744 14 7.99945C14 8.28167 13.8255 8.53517 13.5613 8.63433L9.97869 9.97685L8.63384 13.5613C8.53459 13.8254 8.28214 14 8 14C7.71785 14 7.46541 13.8254 7.36616 13.5613L6.02021 9.97685L2.43873 8.63433C2.17447 8.53517 2 8.28168 2 7.99945C2.0002 7.71743 2.17465 7.46478 2.43873 7.36567L6.02021 6.02205L7.36616 2.43869L7.41025 2.3439C7.52894 2.13352 7.75312 2 8 2Z",
    stroke: "#475467",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiSparkle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ai-sparkle.b94bddd36e0a26b1a744ec389b50c29b.svg";